import { CapoPlugin } from "/vercel/path0/nuxt/node_modules/.pnpm/@unhead+vue@1.11.9_vue@3.4.38_typescript@5.4.5_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];